import { z } from 'zod'

/**
 * Collecte des consentements (docs/sms/collecte-consentements.md) : aperçu avant envoi, invitation par courriel,
 * demande « Répondez OUI » par SMS. Cibles : clients ayant un contrat actif ou à signer. Le serveur choisit.
 */
export const consentCollectionPreviewSchema = z.object({
  clients: z.number(),
  blocked: z.number(),
  alertsGranted: z.number(),
  adminGranted: z.number(),
  withoutEmail: z.number(),
  emailEligible: z.number(),
  smsEligible: z.number(),
  smsMode: z.enum(['DISABLED', 'SIMULATION', 'TEST', 'PRODUCTION']),
  requestWording: z.string(),
})
export type ConsentCollectionPreview = z.infer<typeof consentCollectionPreviewSchema>

export const consentInvitationResultSchema = z.object({
  sent: z.number(),
  failed: z.number(),
  alreadySent: z.number(),
})
export type ConsentInvitationResult = z.infer<typeof consentInvitationResultSchema>

export const consentRequestResultSchema = z.object({
  queued: z.number(),
  replayed: z.number(),
  blocked: z.record(z.string(), z.number()),
})
export type ConsentRequestResult = z.infer<typeof consentRequestResultSchema>

/** Total des demandes refusées par le module (mode TEST, plafond, …). */
export function blockedTotal(result: ConsentRequestResult): number {
  return Object.values(result.blocked).reduce((sum, count) => sum + count, 0)
}
